import { useMemo } from 'react';
import { useLocalizeText } from '@mews-framework/localization';
import { dayNameKeys, dayShortNameKeys, monthNameKeys, monthShortNameKeys } from './dateTimeNames';

export const useLocalizedDayNames = () => {
    const localizeText = useLocalizeText();
    return useMemo(() => dayNameKeys.map((day) => localizeText({ textKey: day })), [localizeText]);
};

export const useLocalizedDayShortNames = () => {
    const localizeText = useLocalizeText();
    return useMemo(() => dayShortNameKeys.map((day) => localizeText({ textKey: day })), [localizeText]);
};

export const useLocalizedMonthNames = () => {
    const localizeText = useLocalizeText();
    return useMemo(() => monthNameKeys.map((month) => localizeText({ textKey: month })), [localizeText]);
};

export const useLocalizedMonthShortNames = () => {
    const localizeText = useLocalizeText();
    return useMemo(() => monthShortNameKeys.map((month) => localizeText({ textKey: month })), [localizeText]);
};
